/**
 * Menu Vuex
 */
import * as API from '@/endpoints'
import Axios from 'axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    alliances: {
      data: {},
      isLoading: false
    }
  },
  mutations: {
    setDataAlliances(state, v) {
      Vue.set(state.alliances, 'data', v)
    },
    setLoadingAlliances(state, v) {
      Vue.set(state.alliances, 'isLoading', v)
    }
  },
  actions: {
    getAlliances ({ commit, dispatch }, {keyword}) {
      return new Promise((resolve, reject) => {

        let url = API.endpoints.base + 'doctor/developed/careplan?group_id=1&type=alliance&unpublish=1';
        if ( keyword ) url += '&search=' + keyword;

        commit('setLoadingAlliances', true)
        Axios.get(url)
          .then(res => {
            commit('setDataAlliances', res.data)
            commit('setLoadingAlliances', false)
            resolve(res.data)
          }, error => {
            dispatch('exceptionHandling', { _err: error }, { root: 1 })
            commit('setLoadingAlliances', false)
            reject(error)
          })
      })
    }
  }
}
